<template>
  <div
    class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 border border-blueGray-200 rounded-lg"
  >
    <div class="rounded-t mb-0 px-4 py-3 border-0">
      <div class="flex flex-wrap items-center">
        <div class="relative w-full px-4 max-w-full flex-grow flex-1">
          <h3 class="font-semibold text-base text-blueGray-700">
            <i class="pi pi-wave-pulse"></i> Transaction
          </h3>
        </div>
        <div
          class="relative w-4/12 px-4 max-w-1/2 flex-grow flex-1 text-right"
        >
          filter: 
          <select @change="fetchNewUserPage('')" v-model="category" :disabled="loaders().fetchTransactions" class="border-0 px-3 py-2 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-xs shadow focus:outline-none ease-linear transition-all duration-150">
            <option v-for='(cur, i) in transactionList' :key="i" >{{ cur }}</option>
          </select>
          <router-link
            class="bg-blueGray-900 text-white active:bg-blueGray-800 text-xs px-4 py-2 ml-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150 max-w-full"
            to="transactions"
          >
            <i class="pi pi-eye text-xs" style="font-size: 10px;"></i> See More
          </router-link>
        </div>
      </div>
    </div>
    <div class="block w-full overflow-x-auto">
      <!-- Projects table -->
      <table class="items-center w-full bg-transparent border-collapse">
        <thead>
          <tr>
            <th
              class="px-6 bg-blueGray-50 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left"
            >
              <i class="pi pi-user mr-1"></i>Customer
            </th>
            <th
              class="px-6 bg-blueGray-50 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left"
            >
              <i class="pi pi-tag mr-1"></i>Type
            </th>
            <th
              class="px-6 bg-blueGray-50 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left"
            >
              <i class="pi pi-dollar mr-1"></i>Amount/<small>Fee</small>
            </th>
            <th
              class="px-6 bg-blueGray-50 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left"
            >
              <i class="pi pi-wallet mr-1"></i>Balance
              <small>Before / After</small>
            </th>
            <th
              class="px-6 bg-blueGray-50 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left"
            >
              <i class="pi pi-bookmark mr-1"></i>Reference
            </th>
            
          </tr>
        </thead>
        <tbody v-if="has('transaction.view')">
          <template v-if="!loaders().fetchTransactions">
            <tr v-for="(trnx, i) in dashboardTransactions" :key="i">
              <td
                class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4"
              >
              <i class="pi pi-user"></i> {{ trnx.user.name }}<br/>
                <small>({{ trnx.user.email }})</small>
              </td>
              <th
                class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-left cursor-pointer"
                :title="trnx.status"
                @click="transaction = {
                  customer_name: trnx.user.name,
                  customer_email: trnx.user.email,
                  reference: trnx.reference,
                  desc: trnx.description, 
                  user_created_at: trnx.user?.created_at,
                  ...parseMeta(trnx.meta)
                }; toggleModal('transaction', true)"
              >
                <span
                  class="inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset lowercase"
                  :class="{
                    'bg-blueGray-900 text-white ring-blueGray-900 ring-opacity-20': trnx.status === 'SUCCESSFUL',
                    'bg-red-200 text-red-600 ring-red-500 ring-opacity-10': trnx.status === 'FAILED',
                    'bg-blueGray-200 text-blueGray-600 ring-blueGray-500 ring-opacity-10': trnx.status === 'PENDING'
                  }"
                >
                  {{ snakeToTitleCase(trnx.category) }}
                </span>
              </th>
              <td
                class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4"
              >
                <i :class="`fas mr-1 ${trnx.type === 'CREDIT' ? 'fa-arrow-up text-emerald-500' : 'fa-arrow-down text-red-500'}`"></i>
                {{ formatAbbrCurrency({amount: trnx.gross_amount, currency: trnx.currency}) }}/<small>{{ formatAbbrCurrency({amount: trnx.charge, currency: trnx.currency}) }}</small>
              </td>   
              <td
                class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4"
              >
                {{ formatter(trnx.currency).format(parseMeta(trnx.meta).balance_before || 0) }} /
                {{ formatter(trnx.currency).format(parseMeta(trnx.meta).balance || 0) }}
              </td>     
              <td
                class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs p-4 max-w-[10rem]"
                :title="trnx.reference"
              >
                <span class="block truncate">{{ trnx.reference }}</span>
              </td>
              
            </tr>
          </template>
          <template v-else>
            <tr>
              <td colspan="5" rowspan="5">
                <div class="flex items-center justify-center w-full py-12 h-30">
                  <span class="loader block"></span>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
      <permission-err v-if="!has('transaction.view')"></permission-err>
      <empty-list 
        v-if="(!transactions().data || transactions().data.length === 0) && !loaders().fetchTransactions && has('transaction.view')"
      ></empty-list>
    </div>
    <transition-group>
        <transition name="bounce" :duration="{ enter: 500, leave: 800 }">
          <div v-if="modals.transaction" style="width: 100%;" class="overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center flex w-screen h-screen top-0 left-0">
            <div class="relative w-auto my-6 mx-auto">
              <!--content-->
              <div class="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                <!--header-->
                <div class="flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t">
                  <h3 class="text-xl font-semibold">
                    Transaction
                  </h3>
                  <button 
                    class="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none" 
                    v-on:click="toggleModal('transaction', false)"
                  >
                    <span class="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                      ×
                    </span>
                  </button>
                </div>
                <!--body-->
                <recursive-table :data="transaction" :exclude="['id']" :copies="['customer_email', 'reference']" />
                <div class="flex items-center justify-end p-4 border-t border-solid border-blueGray-200 rounded-b">
                  <router-link 
                    class="text-blueGray-900 background-transparent capitalize px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                    :to="`/admin/transactions?search=${transaction.customer_email}`"
                  >
                    View more {{ transaction.customer_name }} transactions
                  </router-link>

                  <button 
                    class="text-red-500 background-transparent capitalize px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button" 
                    v-on:click="toggleModal('transaction', false)"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </transition>
        <transition name="bounce" :duration="{ enter: 500, leave: 800 }">
          <div v-if="modals.transaction" style="width: 100%; opacity: 0.25;" class="opacity-25 fixed inset-0 z-40 h-screen top-0 left-0 bg-black"></div>
        </transition>
    </transition-group>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { transactionList, formatter, snakeToTitleCase } from '../../utils'
import { formatAbbrCurrency } from '../../utils/formatter.util'
import RecursiveTable from '@/components/Tables/RecursiveTable.vue';
import EmptyList from "@/components/Cards/EmptyList.vue";
import PermissionErr from "@/components/Cards/PermissionErr.vue";

export default {
  components: {
    RecursiveTable,
    EmptyList,
    PermissionErr
  },
  // props: ["data"],
  data() {
    return {
      category: "",
      transactionList,
      modals: {},
      transaction: {}
    }
  },
  computed: {
    // This is the dashboard's "recent activity" preview, not the full Transactions
    // page — the backend still returns its normal page of 15 (changing that page
    // size would also affect the real Transactions list, which isn't the ask here),
    // so just show the first 5 of whatever came back.
    dashboardTransactions() {
      return (this.transactions().data || []).slice(0, 5);
    }
  },
  methods: {
    ...mapActions(["getTransactions", "reverse"]),
    ...mapGetters(["transactions", "loaders"]),
    ...mapMutations(["updateTransactionQueryParams"]),
    fetchNewUserPage(q) {
      this.updateTransactionQueryParams({category: this.category, q})
      this.$emit('transactionChange', {category: this.category, q})
      this.getTransactions({category: this.category, q})
    },
    toggleModal(modalName, isvisible) {
      this.modals[modalName] = isvisible
    },
    // A single malformed `meta` value used to throw here and break the whole row's
    // click-to-view (and the balance columns) with an uncaught JSON parse error.
    parseMeta(meta) {
      try {
        return JSON.parse(meta || "{}") || {};
      } catch (e) {
        return {};
      }
    }
  },
  mounted() {
    this.getTransactions()
  },
  created() {
    this.formatAbbrCurrency = formatAbbrCurrency
    this.formatter = formatter
    this.snakeToTitleCase = snakeToTitleCase
  }
}
</script>
